import React from 'react';

const ButtonContainer = (props) => (
  <div className="bs-input-container">{props.children}</div>
);

export default ButtonContainer;
